import { render } from "./usingReport.vue?vue&type=template&id=52bd0ee9&scoped=true"
import script from "./usingReport.vue?vue&type=script&lang=js"
export * from "./usingReport.vue?vue&type=script&lang=js"

import "./usingReport.vue?vue&type=style&index=0&id=52bd0ee9&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52bd0ee9"]])

export default __exports__